<button
  type="button"
  class="tw-w-full tw-flex tw-items-center tw-justify-between tw-p-2 tw-text-start disabled:tw-cursor-not-allowed"
  [attr.aria-pressed]="selected()"
  [disabled]="disabled()"
  (click)="onSelect()"
>
  <span
    class="tw-font-inter tw-text-sm"
    [ngClass]="disabled() ? 'tw-text-gray-300' : selected() ? 'tw-font-medium tw-text-gray-900' : 'tw-text-gray-500'"
  >
    {{ label() }}
  </span>

  @if (selected()) {
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.00878 12.8346C4.7803 12.8357 4.56052 12.7284 4.39647 12.5356L0.264208 7.67501C0.181845 7.57754 0.116126 7.46136 0.0708037 7.3331C0.0254817 7.20484 0.00144401 7.06702 6.31568e-05 6.9275C-0.00272561 6.64572 0.086941 6.37415 0.249337 6.17251C0.411734 5.97088 0.633557 5.8557 0.866009 5.85232C1.09846 5.84894 1.3225 5.95763 1.48884 6.15449L5.01228 10.2972L12.5105 1.46991C12.6771 1.27306 12.9014 1.16448 13.134 1.16805C13.3666 1.17163 13.5885 1.28708 13.7509 1.489C13.9133 1.69091 14.0029 1.96276 13.9999 2.24473C13.997 2.5267 13.9017 2.7957 13.7352 2.99256L5.6211 12.5356C5.45705 12.7284 5.23727 12.8357 5.00878 12.8346Z" fill="#1C64F2"/>
    </svg>      
  }
</button>
